// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2ntqnpSjx{position:relative;width:100%;display:flex;flex-direction:column}._2EP6HRkHx{height:auto;width:100%;flex-grow:1;width:inherit;display:flex;flex-direction:column;box-sizing:border-box}._1NH3Dgs7x{margin-top:48px}\n", ""]);
// Exports
exports.locals = {
	"page": "_2ntqnpSjx",
	"scroll-container": "_2EP6HRkHx",
	"scrollContainer": "_2EP6HRkHx",
	"scroll-container-with-nav-bar": "_1NH3Dgs7x _2EP6HRkHx",
	"scrollContainerWithNavBar": "_1NH3Dgs7x _2EP6HRkHx"
};
module.exports = exports;
